<template>
    <div v-if="activeImage" class="overlay-header">
        <button class="btn-icon icon-close" @click="$emit('canceled')"></button>
        {{ getImageTitle(activeImage) }}
    </div>
</template>

<script>
  export default {
    props: {
      images: {
        type: Array
      },
      activeImage: {
        type: Object,
        required: true
      },
      dropzoneFiles: {
        type: Array
      }
    },
    computed: {
      getImageTitle () {
        return (image) => {
          if (image.title) {
            return image.title
          }
          if (this.dropzoneFiles && image.uuid) {
            let obj = this.dropzoneFiles.find(obj => obj.upload.uuid === image.uuid)
            return obj.name
          }
          return ''
        }
      }
    }
  }
</script>

<style scoped>

</style>
